import {HttpHeaders} from "@angular/common/http";
export class UserCredentials {
    user_pass: string = "";
    user_name: string = "";
    constructor(user_name?:string,user_pass?:string){
        if(user_name!=null){this.user_name=user_name;}
        if(user_pass!=null){this.user_pass=user_pass;}
    }
}

export class UserSession {
    token: string = "";
    expire: string = "";
    ttl: number = -1;
    constructor(newUserSession?:Object){
        if(newUserSession != null){
            if(newUserSession.hasOwnProperty('token')){
                this.token = newUserSession['token'];
            }
            if(newUserSession.hasOwnProperty('expire')){
                this.expire = newUserSession['expire'];
            }
            if(newUserSession.hasOwnProperty('ttl')){
                this.ttl = newUserSession['ttl'];
            }
        }
    }
}

export class HttpOptions{
    headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache'
    });
    status:boolean=false;
    constructor(userSession?:UserSession){
        if(userSession != null){
            this.headers = new HttpHeaders({
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods' : 'PUT, GET, POST, DELETE, OPTIONS',
                'Cache-Control': 'no-cache',
                'Authorization': 'Bearer ' + userSession.token
            });
            this.status=true;
        }
    }
    setHttpHeaders(headers:HttpHeaders){
        this.headers = headers;
    }
}

export class UserLogOutRequest{
    message: string = "";
    token: string = "";
    constructor(message?:string,token?:string){
        if(message != null){
            this.message = message;
        }
        if(token != null){
            this.token = token;
        }
    }
}


export class UserCookTokenCheckRequest{

    message: string = "";
    token: string = "";
    status: boolean = true;
    ttl: number = -1;
    lifeTime: number = -1;

    constructor(message?:string,token?:string, status?: boolean, ttl?: number, lifeTime?: number){
        if(message != null){
            this.message = message;
        }
        if(token != null){
            this.token = token;
        }
        if(status != null){
            this.status = status;
        }
        if(ttl != null){
            this.ttl = ttl;
        }
        if(lifeTime != null){
            this.lifeTime = lifeTime;
        }
    }
}
